module.exports = __webpack_public_path__ + "img/tooltip.9294bf43.svg";